/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { Error400CodeEnum, Error404CodeEnum, Error500CodeEnum } from 'client-code/myshows';

import { AppError } from './AppError';
import { ErrorTypes } from './ErrorTypes';

export class MyshowFiltersError extends AppError {
    public constructor(code: string, message: string) {
        super(code, message);
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case Error400CodeEnum.ApigwError:
                this.code = ErrorTypes.MY_SHOWS_APIGATEWAY_ERROR_C1501;
                this.type = Error400CodeEnum.ApigwError;
                break;
            case Error400CodeEnum.BadRequest:
                this.code = ErrorTypes.MY_SHOWS_BADREQUEST_ERROR_C1502;
                this.type = ErrorTypes.MY_SHOWS_BADREQUEST_ERROR_C1502;
                break;
            case Error404CodeEnum.ResourceNotFound:
                this.code = ErrorTypes.MY_SHOWS_RESOURCE_NOT_FOUND_ERROR_C1503;
                this.type = Error404CodeEnum.ResourceNotFound;
                break;
            case Error500CodeEnum.InternalServerError:
                this.code = ErrorTypes.MY_SHOWS_INTERNAL_SERVER_ERROR_C1504;
                this.type = Error500CodeEnum.InternalServerError;
                break;
            default:
                this.code = ErrorTypes.MY_SHOWS_UNKNOWN_ERROR_C1599;
                this.type = 'MYSHOWS_UNKNOWN_ERROR';
        }
    }
}
